import { useRouter } from 'next/router'

import { isSSR } from '~utilities/ssr.utilities'

function useGoBack() {
  const router = useRouter()

  return (destiny: string) => {
    if (isSSR()) {
      return
    }

    if (document.referrer.split('/')[2] === window.location.host) {
      router.back()
      return
    }

    router.push(destiny)
  }
}

export default useGoBack
